// スクロール式カルーセルとバリアントの連動
document.addEventListener('DOMContentLoaded', function() {
  console.log('スクリプト開始');
  
  const productGallery = document.querySelector('product-gallery');
  if (!productGallery) return;
  
  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) return;
  
  // 商品データを取得してマッピングを作成
  fetch(window.location.pathname + '.js')
    .then(r => r.json())
    .then(data => {
      // メディアID → バリアントのマッピング
      const variantMediaMap = {};
      
      data.variants.forEach(function(v) {
        if (v.featured_image && v.featured_image.src) {
          const media = data.media.find(m => 
            m.preview_image && 
            m.preview_image.src && 
            m.preview_image.src.includes(v.featured_image.src.split('/').pop().split('?')[0])
          );
          if (media) {
            variantMediaMap[media.id] = v;
          }
        }
      });
      
      console.log('マッピング作成完了');
      
      // スクロールコンテナ
      const scrollContainer = productGallery.querySelector('[role="region"]') || productGallery;
      
      // スクロール終了時に実行
      let scrollTimeout;
      scrollContainer.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        
        scrollTimeout = setTimeout(function() {
          const mediaItems = productGallery.querySelectorAll('.product-gallery__media');
          
          mediaItems.forEach(function(media) {
            const rect = media.getBoundingClientRect();
            const containerRect = scrollContainer.getBoundingClientRect();
            
            // 画像が中央に表示されているか確認
            if (rect.left >= containerRect.left && rect.left < containerRect.right) {
              const mediaId = media.getAttribute('data-media-id');
              const variant = variantMediaMap[mediaId];
              
              if (variant) {
                console.log('表示中:', variant.option1);
                
                // option1の値に一致するlabelを探す
                const labels = variantPicker.querySelectorAll('label[for*="option1"]');
                
                labels.forEach(function(label) {
                  if (label.textContent.trim() === variant.option1) {
                    const inputId = label.getAttribute('for');
                    const input = document.getElementById(inputId);
                    
                    if (input && !input.checked && !input.disabled) {
                      console.log('バリアント自動選択:', variant.option1);
                      input.checked = true;
                      input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                });
              }
            }
          });
        }, 200);
      });
      
      console.log('設定完了');
    })
    .catch(err => console.error('エラー:', err));
});
